export default __webpack_public_path__ + "09b89f1da749920d6a7ce57d56f4d790.png";